// =============================================================================
// GRAPHIQUES PANEL - Orchestrateur
// =============================================================================

import React from 'react';
import { ChantierRentabilite } from '@/hooks/useChantiersFiltresRentabilite';
import { useGraphiquesStore } from './useGraphiquesStore';
import GraphiquesPanelCollapsed from './GraphiquesPanelCollapsed';
import GraphiquesPanelExpanded from './GraphiquesPanelExpanded';

interface GraphiquesPanelProps {
  chantiers: ChantierRentabilite[];
}

/**
 * Panneau Graphiques pour la page Rentabilité
 * - Onglet replié (120px) : toujours visible à droite
 * - Panneau déplié : affiche 3 graphiques globaux avec onglets
 */
export function GraphiquesPanel({ chantiers }: GraphiquesPanelProps) {
  const { isOpen, activeTab, openPanel, closePanel, setActiveTab } = useGraphiquesStore();

  return (
    <>
      {/* Onglet replié - visible quand fermé */}
      <GraphiquesPanelCollapsed
        isVisible={!isOpen}
        onExpand={openPanel}
        nombreChantiers={chantiers.length}
      />

      {/* Panneau déplié - visible quand ouvert */}
      <GraphiquesPanelExpanded
        isVisible={isOpen}
        onClose={closePanel}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        chantiers={chantiers}
      />
    </>
  );
}

export { useGraphiquesStore } from './useGraphiquesStore';
